var _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegramm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.2264,
    cy: 16.5,
    rx: 16.2264,
    ry: 16.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.28453 16.9086L12.0151 18.3231L13.4693 23.081C13.5326 23.4024 13.9119 23.4667 14.1648 23.2738L16.2514 21.5379C16.4411 21.345 16.7572 21.345 17.0102 21.5379L20.7407 24.3026C20.9936 24.4954 21.373 24.3669 21.4362 24.0454L24.2183 10.5434C24.2815 10.2219 23.9654 9.90044 23.6492 10.029L8.28453 16.0728C7.90516 16.2014 7.90516 16.78 8.28453 16.9086ZM13.2796 17.6159L20.6142 13.0509C20.7407 12.9866 20.8671 13.1795 20.7407 13.2438L14.7339 18.9661C14.5442 19.159 14.3545 19.4161 14.3545 19.7376L14.1648 21.2807C14.1648 21.4736 13.8487 21.5379 13.7855 21.2807L13.0267 18.4517C12.837 18.1302 12.9635 17.7445 13.2796 17.6159Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramm);
export default __webpack_public_path__ + "static/media/telegramm.8ccd7f3b73db27cf40894ba2ddcb501b.svg";
export { ForwardRef as ReactComponent };